import {useDispatch} from 'react-redux'
import {showAlert} from '../../redux/reducers/alertSlice'
import api from '../../../_metronic/helpers/api'
import {useNavigate} from 'react-router-dom'
import {stringify} from 'qs'

export default function useUtils() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleAutoRenewal = () => {
    dispatch(showAlert({message: `Not Editable`, variant: 'danger', timeout: '1000'}))
  }

  const handleEdit = async (data, id) => {
    try {
      const response = await api.patch(`/subscription/${id}`, data)
      if (response.data.status) {
        dispatch(
          showAlert({
            message: `Successfully Edited`,
            variant: 'success',
            timeout: '2000',
          })
        )
        navigate('/subscriptionlist')
        fetchSubscriptions()
      }
    } catch (error) {
      dispatch(showAlert({message: error?.response?.data?.message, variant: 'danger'}))
    }
  }

  const fetchSubscriptions = async (limit = 12, offset = 0, subscription, currenncy) => {
    try {
      const params = {
        limit,
        offset,
        relations: ['subscriptionBenefits.benefit'],
        where: {},
      }

      if (currenncy !== null) {
        params.returnSubscriptions = currenncy
      }

      if (subscription !== null) {
        params.where.isActive = subscription
      }

      const response = await api.get(`/subscription?${stringify(params)}`)

      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message ?? 'Network Error',
          variant: 'danger',
        })
      )
    }
  }

  const fetchBenefits = async () => {
    try {
      const response = await api.get(`/benefit?where[isActive]=true`)
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      console.log(error?.message)
    }
  }

  const addSubscription = async (values) => {
    try {
      const response = await api.post(`/subscription`, values)
      if (response.data.status) {
        dispatch(
          showAlert({
            message: 'Subscription added',
            variant: 'success',
          })
        )
        navigate('/subscriptionlist')
      } else {
        dispatch(showAlert({message: response?.error?.data?.message, variant: 'danger'}))
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message ?? 'network error',
          variant: 'danger',
        })
      )
    }
  }

  const handleDelete = async (id, isActive, limit, offset) => {
    console.log(limit, offset)
    try {
      const response = await api.patch(`/subscription/${id}`, {
        isActive,
      })
      if (response.data.status) {
        dispatch(
          showAlert({
            message: isActive ? 'Successfully Activated' : 'Successfully Deactivated',
            variant: 'success',
            timeout: '3000',
          })
        )
        return fetchSubscriptions(limit, offset)
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message ?? 'Network Error',
          variant: 'danger',
        })
      )
    }
  }
  return {handleAutoRenewal, fetchBenefits, handleEdit, handleDelete, addSubscription, fetchSubscriptions}
}
